import { LegalPage } from '../components/LegalPage';

export default function AGB() {
  return (
    <LegalPage title="Allgemeine Gesch&auml;ftsbedingungen (AGB)" isPlaceholder={false}>
      <h2>1. Geltungsbereich</h2>
      <p>
        Diese Allgemeinen Gesch&auml;ftsbedingungen gelten f&uuml;r die Nutzung des Online-Tools <strong>berater-digital.de</strong>, betrieben von:
      </p>
      <address>
        StartKlar.Digital Agentur<br />
        Christine &amp; Andreas Helm GbR<br />
        Clara-Schumann-Str. 2<br />
        97980 Bad Mergentheim
      </address>
      <p>
        Die AGB gelten f&uuml;r alle Vertr&auml;ge zwischen dem Anbieter und den Nutzern des Tools.
      </p>

      <h2>2. Leistungsbeschreibung</h2>
      <p>
        Das Tool erm&ouml;glicht die Erstellung, Bearbeitung und Optimierung von Inhalten (z.&nbsp;B. Beratungsberichte) unter Einsatz automatisierter Prozesse und K&uuml;nstlicher Intelligenz (KI).
      </p>
      <p>
        Der Anbieter stellt die technischen Funktionen zur Verf&uuml;gung, schuldet jedoch keinen konkreten Erfolg oder ein bestimmtes Ergebnis.
      </p>

      <h2>3. Registrierung und Nutzerkonto</h2>
      <p>Die Nutzung des Tools setzt die Erstellung eines Nutzerkontos voraus.</p>
      <p>Der Nutzer ist verpflichtet:</p>
      <ul>
        <li>wahrheitsgem&auml;&szlig;e Angaben zu machen</li>
        <li>Zugangsdaten vertraulich zu behandeln</li>
        <li>den Zugriff durch Dritte zu verhindern</li>
      </ul>
      <p>Der Anbieter ist berechtigt, Konten bei Verst&ouml;&szlig;en zu sperren oder zu l&ouml;schen.</p>

      <h2>4. Preise und Zahlungsbedingungen</h2>
      <p>Die Nutzung des Tools ist kostenpflichtig.</p>
      <p>
        Die jeweils g&uuml;ltigen Preise und Abrechnungsmodelle (z.&nbsp;B. Abonnement) ergeben sich aus den auf der Website dargestellten Konditionen.
      </p>
      <p>Zahlungen sind im Voraus f&auml;llig.</p>
      <p>
        Der Anbieter ist berechtigt, Preise unter Ber&uuml;cksichtigung der Marktbedingungen anzupassen. Nutzer werden hier&uuml;ber rechtzeitig informiert.
      </p>

      <h2>5. Nutzung der Inhalte und KI-Hinweis</h2>
      <p>
        Die im Tool generierten Inhalte basieren auf automatisierten Prozessen und K&uuml;nstlicher Intelligenz.
      </p>
      <p><strong>Wichtiger Hinweis:</strong></p>
      <ul>
        <li>Die Inhalte stellen ausschlie&szlig;lich Vorschl&auml;ge dar</li>
        <li>Es wird keine Gew&auml;hr f&uuml;r Richtigkeit, Vollst&auml;ndigkeit oder rechtliche Zul&auml;ssigkeit &uuml;bernommen</li>
        <li>Die Inhalte ersetzen keine individuelle Beratung</li>
      </ul>
      <p>Der Nutzer ist verpflichtet, alle Inhalte eigenst&auml;ndig zu pr&uuml;fen.</p>
      <p>Die Nutzung erfolgt auf eigene Verantwortung.</p>

      <h2>6. Nutzungsrechte</h2>
      <p>
        Die vom Nutzer erstellten und generierten Inhalte stehen grunds&auml;tzlich dem Nutzer zur Verf&uuml;gung.
      </p>
      <p>
        Der Anbieter ist berechtigt, Inhalte in anonymisierter Form zur Verbesserung des Systems zu verwenden.
      </p>

      <h2>7. Nutzungsbeschr&auml;nkungen</h2>
      <p>Es ist untersagt, das Tool zu verwenden f&uuml;r:</p>
      <ul>
        <li>rechtswidrige Inhalte</li>
        <li>beleidigende oder diskriminierende Inhalte</li>
        <li>Verarbeitung sensibler personenbezogener Daten ohne Rechtsgrundlage</li>
      </ul>
      <p>Der Anbieter ist berechtigt, Inhalte zu entfernen und Nutzerkonten zu sperren.</p>

      <h2>8. Verf&uuml;gbarkeit und Support</h2>
      <p>
        Der Anbieter bem&uuml;ht sich um eine m&ouml;glichst unterbrechungsfreie Verf&uuml;gbarkeit des Tools.
      </p>
      <p>Eine durchgehende Verf&uuml;gbarkeit kann jedoch nicht garantiert werden.</p>
      <p>
        Wartungsarbeiten, Weiterentwicklungen oder technische St&ouml;rungen k&ouml;nnen zu Einschr&auml;nkungen f&uuml;hren.
      </p>
      <p>
        Support erfolgt im Rahmen der technischen M&ouml;glichkeiten, ohne Anspruch auf bestimmte Reaktionszeiten.
      </p>

      <h2>9. Vertragslaufzeit und K&uuml;ndigung</h2>
      <p>Der Vertrag kann vom Nutzer jederzeit gek&uuml;ndigt werden.</p>
      <p>Die K&uuml;ndigung erfolgt durch L&ouml;schung des Nutzerkontos oder entsprechende Mitteilung.</p>
      <p>Der Anbieter ist berechtigt, Vertr&auml;ge aus wichtigem Grund fristlos zu k&uuml;ndigen.</p>
      <p>Nach K&uuml;ndigung gelten die Regelungen zur Datenl&ouml;schung gem&auml;&szlig; Datenschutzerkl&auml;rung.</p>

      <h2>10. Haftung</h2>
      <p>Der Anbieter haftet uneingeschr&auml;nkt bei Vorsatz.</p>
      <p>
        Bei grober Fahrl&auml;ssigkeit und bei Verletzung wesentlicher Vertragspflichten haftet der Anbieter nur in H&ouml;he des vorhersehbaren Schadens.
      </p>
      <p>
        Eine Haftung f&uuml;r die inhaltliche Richtigkeit der durch KI generierten Inhalte ist ausgeschlossen.
      </p>
      <p>
        Die Haftung f&uuml;r Datenverlust ist auf den typischen Wiederherstellungsaufwand beschr&auml;nkt, sofern der Nutzer keine eigenen Sicherungen vorgenommen hat.
      </p>

      <h2>11. &Auml;nderungen der AGB</h2>
      <p>
        Der Anbieter beh&auml;lt sich vor, diese AGB jederzeit mit Wirkung f&uuml;r die Zukunft zu &auml;ndern.
      </p>

      <h2>12. Schlussbestimmungen</h2>
      <p>Es gilt das Recht der Bundesrepublik Deutschland.</p>
      <p>Gerichtsstand ist – soweit zul&auml;ssig – der Sitz des Anbieters.</p>
      <p>
        Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der &uuml;brigen Regelungen unber&uuml;hrt.
      </p>
    </LegalPage>
  );
}
